var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgO2 = function SvgO2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2A2.5 2.5 0 0 0 9 4.5a2.36 2.36 0 0 0 .13.75L4.39 7.88A2.49 2.49 0 1 0 5 9.5a2.36 2.36 0 0 0-.13-.75l4.74-2.63A2.5 2.5 0 1 0 11.5 2Z"
  })));
};

export default SvgO2;